<template>
  <v-dialog
    max-width="500"
    v-model="dialog.shows.showTransferTester"
    persistent
  >
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
        <v-spacer></v-spacer>
        <v-icon @click="dialog.shows.showTransferTester = false" color="red"
          >mdi-close</v-icon
        >
      </v-card-title>
      <v-divider></v-divider>
      <v-form @submit.prevent="sendForm">
        <v-card-text>
          <template v-if="!form.api_key">
            <v-autocomplete
              :items="itemsApplications"
              :label="$vuetify.lang.t('$vuetify.tester.cols.application.title')"
              :loading="isLoadingApp"
              :search-input.sync="searchApp"
              autocomplete="off"
              clearable
              hide-no-data
              hide-selected
              prepend-icon="mdi-apps"
              v-model="form.application"
              return-object
            ></v-autocomplete>
          </template>
          <v-select
            :class="{ 'mb-4': form.type !== 'OM' }"
            :error="!_.isNull(apiFormErrors['type'])"
            :error-messages="
              !_.isEmpty(errorsType) ? errorsType : apiFormErrors['type']
            "
            :items="operators"
            :label="$vuetify.lang.t('$vuetify.tester.cols.type.title')"
            :messages="[$vuetify.lang.t('$vuetify.tester.cols.type.title2')]"
            @blur="$v.form.type.$touch()"
            @input="$v.form.type.$touch()"
            class="operator"
            prepend-icon="mdi-transfer"
            v-model="form.type"
          >
            <template class="test" slot="selection" slot-scope="data">
              <v-avatar class="mb-2 mt-2">
                <img :src="data.item.avatar" />
              </v-avatar>
              <div class="ml-2 my-auto">{{ data.item.text }}</div>
            </template>
            <template class="test2" slot="item" slot-scope="data">
              <v-list-item-avatar>
                <img :src="data.item.avatar" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ data.item.text }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-select>
          <v-text-field
            :error-messages="
              !_.isEmpty(errorsAccountNumber)
                ? errorsAccountNumber
                : apiFormErrors['account_number']
            "
            :label="$vuetify.lang.t('$vuetify.tester.cols.accountNumber.title')"
            @blur="$v.form.account_number.$touch()"
            @input="$v.form.account_number.$touch()"
            autocomplete="off"
            prepend-icon="mdi-cellphone-iphone"
            v-model="form.account_number"
          ></v-text-field>
          <v-text-field
            :error="!_.isNull(apiFormErrors['amount'])"
            :error-messages="
              !_.isEmpty(errorsAmount) ? errorsAmount : apiFormErrors['amount']
            "
            :label="$vuetify.lang.t('$vuetify.tester.cols.amount.title')"
            @blur="$v.form.amount.$touch()"
            @input="$v.form.amount.$touch()"
            autocomplete="off"
            prepend-icon="mdi-cash"
            v-model="form.amount"
          ></v-text-field>
          <v-divider></v-divider>
          <v-btn
            :disabled="$v.$invalid || loadingResponseBtn"
            :loading="loadingBtn"
            block
            color="primary"
            large
            type="submit"
            >{{ $vuetify.lang.t("$vuetify.tester.btn.save.title") }}
          </v-btn>
        </v-card-text>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import FormMixin from "../../mixins/Common/Forms";
import {
  required,
  helpers,
  between,
  minValue,
  numeric,
  requiredIf
} from "vuelidate/lib/validators";
import URLPath from "../../helpers/URL";
import CONSTANTS from "../../helpers/Constants";
import Util from "../../helpers/Utils";

const phoneNumberMatch = provider => {
  return value => {
    if (!helpers.req(value)) {
      return true;
    } else {
      if (!provider) {
        return false;
      } else {
        let valid = false;
        switch (provider) {
          case "OM":
            valid = /^6((9[0-9]{7})|(5[5-9][0-9]{6})|(8[6-9][0-9]{6}))$/.test(
              value
            );
            break;
          case "MOMO":
            valid = /^6((7[0-9]{7})|(5[0-4][0-9]{6})|(8[0-4][0-9]{6}))$/.test(
              value
            );
            break;
          // case "EUM":
          //   valid = /^(6([5-9][0-9]{7}))|((242|243)[0-9]{6})$/.test(value);
          //   break;
        }
        return valid;
      }
    }
  };
};
const accountTypeMatch = value =>
  !helpers.req(value) || ["OM", "MOMO", "EUM"].indexOf(value) > -1;

export default {
  mixins: [FormMixin],
  props: {
    form: {
      type: Object,
      default: function() {
        return {
          application: null,
          amount: null,
          notif_url: null,
          type: null,
          api_key: null,
          secret: null,
          account_number: null,
          user: null
        };
      }
    },
    dialog: {
      type: Object,
      default: function() {
        return {
          title: "$vuetify.application.new.title",
          shows: {
            showTransferTester: false
          },
          saveBtnTitle: "$vuetify.btn.save",
          action: "create"
        };
      }
    },
    fromApplication: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  watch: {
    searchApp(val) {
      if (!val) return;
      if (val.length < 3) return;
      const query = "a_name::iLike::%" + val + "%";
      const params = {
        url: URLPath.APPLICATION.LIST,
        params: {
          _search: query
        }
      };
      this.getApplications(params);
    }
  },
  validations() {
    return {
      form: {
        application: {
          required: requiredIf(component => {
            return !component["api_key"];
          })
        },
        account_number: {
          required,
          phoneNumberMatch: phoneNumberMatch(this.form.type)
        },
        type: { required, accountTypeMatch: accountTypeMatch },
        amount: {
          required,
          numeric,
          between: function(value) {
            let min = CONSTANTS.defaultTransferSetting().amount_min;
            let max = CONSTANTS.defaultTransferSetting().amount_max;
            let settings = this.form.user ? this.form.user["settings"] : null;
            if (settings && settings["transfer"]) {
              min = settings["transfer"]["amount_min"];
              max = settings["transfer"]["amount_max"];
            }
            if (max) {
              return between(min, max)(value);
            }
            return minValue(min)(value);
          }
        }
      }
    };
  },
  data: () => ({
    loadingBtn: false,
    loadingResponseBtn: false,
    itemsApplications: [],
    searchApp: null,
    isLoadingApp: false,
    operators: [
      { value: "MOMO", text: "MTN Mobile Money", avatar: "/img/momo.png" },
      { value: "OM", text: "Orange Money", avatar: "/img/om.png" }
      // {value: "EUM", text: "Express Union Mobile", avatar: "/img/eum.png"}
    ]
  }),
  methods: {
    getApplications(params) {
      let self = this;
      this.isLoadingApp = true;
      this.$store
        .dispatch("request", params)
        .then(r => {
          r.data.items.forEach(app => {
            self.itemsApplications.push({
              text: app.name,
              value: app.id,
              userId: app.userId,
              user: app.user,
              appSlug: Util.slugify(app.name),
              apiKey: app.apiKey,
              secret: app.secret
            });
          });
        })
        .finally(() => {
          self.isLoadingApp = false;
        });
    },
    sendForm() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let self = this;
        this.loadingBtn = true;
        this.loadingResponseBtn = false;
        this.save(this.getFormParam())
          .then(() => {
            if (!self.fromApplication) {
              self.dialog.shows.showTransferTester = false;
              self.loadingResponseBtn = true;
              this.resetForm();
              this.$emit("getItems");
            } else {
              self.$router.push({ name: "transfer" });
            }
          })
          .catch(err => {
            if (err.response) {
              if (err.response.status === 400) {
                self.$store.dispatch("setNotification", {
                  status: true,
                  message: err.response.data["message"]
                });
              } else if (err.response.status === 422) {
                if (err.response.data["code"] === "P100") {
                  self.$store.dispatch("setNotification", {
                    status: true,
                    message: this.$vuetify.lang.t(
                      "$vuetify.transfer.msg.title",
                      {
                        min: err.response.data["min_amount"],
                        max: err.response.data["max_amount"]
                      }
                    )
                  });
                } else {
                  self.$store.dispatch("setNotification", {
                    status: true,
                    message: this.$vuetify.lang.t(
                      "$vuetify.transfer.msg.title2"
                    )
                  });
                }
              }
            }
          })
          .finally(() => {
            self.loadingBtn = false;
          });
      }
    },
    getFormParam() {
      let params = {};
      params["url"] = URLPath.TESTER.TRANSFER.INIT.URI;
      params["method"] = URLPath.TESTER.TRANSFER.INIT.METHOD;
      let data = this._.omit(this.form, [
        "application",
        "otp",
        "return_url",
        "user"
      ]);
      if (this.form.application) {
        data["api_key"] = this.form.application["apiKey"];
        data["secret"] = this.form.application["secret"];
      }
      params["data"] = data;
      return params;
    },
    resetForm() {
      this.form.application = null;
      this.form.user = null;
      this.form.amount = null;
      this.form.type = null;
      this.form.api_key = null;
      this.form.secret = null;
      this.form.account_number = null;
      this.$v.$reset();
    }
  },
  computed: {
    errorsApplication() {
      let errors = [];
      if (!this.$v.form.application.$dirty) return errors;

      !this.$v.form.application.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.tester.cols.application.required")
        );
      return errors;
    },
    errorsType() {
      let errors = [];
      if (!this.$v.form.type.$dirty) return errors;

      !this.$v.form.type.required &&
        errors.push(this.$vuetify.lang.t("$vuetify.tester.cols.type.required"));
      return errors;
    },
    errorsAccountNumber() {
      let errors = [];
      if (!this.$v.form.account_number.$dirty) return errors;

      !this.$v.form.account_number.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.tester.cols.accountNumber.required")
        );

      !this.$v.form.account_number.phoneNumberMatch &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.tester.cols.accountNumber.invalid")
        );

      return errors;
    },
    errorsAmount() {
      let errors = [];
      if (!this.$v.form.amount.$dirty) return errors;

      !this.$v.form.amount.required &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.tester.cols.amount.required")
        );

      !this.$v.form.amount.numeric &&
        errors.push(
          this.$vuetify.lang.t("$vuetify.tester.cols.amount.numeric")
        );
      let min = CONSTANTS.defaultTransferSetting().amount_min;
      let max = CONSTANTS.defaultTransferSetting().amount_max;
      if (this.form.user) {
        let settings = this.form.user["settings"];
        if (settings && settings["transfer"]) {
          min = settings["transfer"]["amount_min"];
          max = settings["transfer"]["amount_max"];
        }
      }
      let msg = "";
      if (max) {
        msg = this.$vuetify.lang.t(
          "$vuetify.tester.cols.amount.between",
          [min],
          [max]
        );
      } else {
        msg = this.$vuetify.lang.t(
          "$vuetify.tester.cols.amount.min",[min]);
      }

      !this.$v.form.amount.between && errors.push(msg);
      return errors;
    }
  }
};
</script>

<style scoped></style>
